import { Controller } from 'stimulus'
import './theater_mode_toggle_component.css'

import { applyKeyboardShortcut } from '~/common/components/videojs/keyboard_shortcut'
import {
  THEATER_MODE_DESKTOP_MQ,
  desiredTheaterLayout,
  theaterModeAvailable,
} from './theater_mode'

export default class extends Controller {
  static values = {
    containerId: String,
  }

  connect() {
    this.desktopMediaQuery = window.matchMedia(THEATER_MODE_DESKTOP_MQ)
    this.boundSyncToViewport = () => this.syncToViewport()
    this.desktopMediaQuery.addEventListener('change', this.boundSyncToViewport)
    // Initial apply is the inline script (desktop only). On a phone-sized
    // viewport, drop theater immediately without waiting for a resize.
    if (!theaterModeAvailable()) this.syncToViewport()
  }

  disconnect() {
    this.desktopMediaQuery?.removeEventListener(
      'change',
      this.boundSyncToViewport
    )
  }

  toggleThroughKeypress(e) {
    if (applyKeyboardShortcut(e.target)) {
      this.toggle(e)
    }
  }

  toggle(e) {
    if (!theaterModeAvailable()) return

    if (this.inTheaterMode()) this.moveToNormalContainer()
    else this.moveToTheaterModeContainer()

    window.UserPreference.set('theater_mode', this.inTheaterMode())
  }

  // Apply or drop the layout for the current viewport without writing the preference.
  // A phone visit must not turn theater off for the next desktop visit.
  syncToViewport() {
    const wantTheater = desiredTheaterLayout({
      available: theaterModeAvailable(),
      preferenceOn: !!window.UserPreference?.get('theater_mode'),
    })

    if (wantTheater && !this.inTheaterMode()) this.moveToTheaterModeContainer()
    else if (!wantTheater && this.inTheaterMode()) this.moveToNormalContainer()
  }

  moveToTheaterModeContainer() {
    this.theaterModeContainer?.insertAdjacentElement('beforeend', this.element)
    this.afterMove()
  }

  moveToNormalContainer() {
    document
      .getElementById(this.containerIdValue)
      ?.insertAdjacentElement('beforeend', this.element)
    this.afterMove()
  }

  afterMove() {
    this.resize()
    this.video?.scrollIntoView({
      behavior: 'instant',
      block: 'end',
      inline: 'end',
    })
    document.dispatchEvent(new CustomEvent('theater-mode-toggled'))
  }

  resize() {
    if (!this.video) return

    this.dispatch('simplero:media:resize', {
      target: this.video,
      prefix: false,
    })
  }

  inTheaterMode() {
    return !!this.theaterModeContainer?.contains(this.element)
  }

  get theaterModeContainer() {
    return document.getElementById('theater-mode-container')
  }

  get video() {
    return this.element.querySelector('video')
  }
}
